import React from 'react';
import { Popover } from '@blueprintjs/core';
import { Text } from 'common-components/typography';
import { ActionMenu, ActionMenuItem } from 'common-components/action-menu';
import CommonUtils from 'utilities/common-utils';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { IRosterWorker } from '../../types';
import { IRootDispatch } from 'stores/rematch/root-store';
import { ActionIcon, Avatar, Box } from '@good/ui/core';
import { MoreHoriz } from '@good/icons';

interface WorkerDetailsColumnProps {
  worker: IRosterWorker;
  totalDuration: number;
}

export const WorkerDetailsColumn = ({ worker, totalDuration }: WorkerDetailsColumnProps) => {
  const history = useHistory();
  const { workerLastName, workerFirstName, workerAvatarUrl } = worker;
  const workerFullName = `${workerFirstName} ${workerLastName}`;
  const { navigationStore } = useDispatch<IRootDispatch>();
  const setSelectedSideNavMenuKeys = navigationStore.setSelectedSideNavMenuKeys;

  const goToWorker = () => {
    setSelectedSideNavMenuKeys(['/services']);
    return history.push(`/team/details/${worker.supportWorkerId}`);
  };

  return (
    <Box className='flex-row justify-between' p='sm'>
      <div className='flex-row' style={{ maxWidth: 200 }}>
        <Avatar radius='md' mr='sm' src={workerAvatarUrl} name={workerFullName} />
        <div className='line-height-135 block text-overflow-ellipsis overflow-hidden whitespace-nowrap'>
          <Text lineHeight={120}>{workerFullName}</Text> <br />
          <Text size='regular' color='secondary' lineHeight={135}>
            {CommonUtils.formatHoursFromSeconds(totalDuration)}
          </Text>
        </div>
      </div>

      <Popover
        content={
          <ActionMenu>
            <ActionMenuItem text='View team member profile' onClick={goToWorker} />
          </ActionMenu>
        }
        position={'bottom-left'}
      >
        <ActionIcon variant='default'>
          <MoreHoriz />
        </ActionIcon>
      </Popover>
    </Box>
  );
};
